var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPace = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "pace_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pace_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 18a7.796 7.796 0 01-3.104-.625 8.064 8.064 0 01-2.552-1.719 8.063 8.063 0 01-1.719-2.552A7.797 7.797 0 012 10c0-1.111.208-2.15.625-3.115a8.064 8.064 0 014.27-4.26A7.797 7.797 0 0110 2c1.111 0 2.15.208 3.115.625a8.095 8.095 0 014.26 4.26C17.792 7.851 18 8.89 18 10c0 .375-.024.743-.073 1.104a7.78 7.78 0 01-.219 1.063 2.521 2.521 0 00-.645-.438 2.32 2.32 0 00-.75-.208c.069-.25.118-.5.145-.75.028-.25.042-.507.042-.771 0-1.806-.632-3.34-1.896-4.604C13.34 4.132 11.806 3.5 10 3.5s-3.34.632-4.604 1.896C4.132 6.66 3.5 8.194 3.5 10s.632 3.34 1.896 4.604C6.66 15.868 8.194 16.5 10 16.5c.722 0 1.406-.108 2.052-.323a6.308 6.308 0 001.781-.927c.125.236.285.438.48.604.194.167.41.306.645.417-.68.541-1.44.965-2.28 1.27A7.774 7.774 0 0110 18zm6-3a.964.964 0 01-.708-.292A.964.964 0 0115 14c0-.278.097-.514.292-.708A.964.964 0 0116 13c.278 0 .514.097.708.292.195.194.292.43.292.708a.964.964 0 01-.292.708A.964.964 0 0116 15zm-3.208-1.458L9.25 10V5h1.5v4.375l3.104 3.104-1.062 1.063z",
    fill: "#535366"
  }))));
};
export default SvgPace;